import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "bellWithCheckmark",
    iconColor: "white",
    text: "Alarm context \naccessibility",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "message",
    iconColor: "white",
    text: "Contextual\n answers with Gen AI \nmodule ",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "ai",
    iconColor: "white",
    text: "API to interface with \nGen AI stack",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "questionBubble",
    iconColor: "white",
    text: "Enrich user queries with \nISNA context",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_ISNA_4 = {
  title: "Gen aI capability for rapid response",
  titleNumber: "4.",
  subtitle: "Conversational AI for context specific queries.",
  text: "\nHelp NOC users to respond efficiently and rapidly to network events by\ngenerating useful and actionable insights.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_204"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_Introduction_05.png",
  demoButtons: [
    {
      label: "GEN AI DEMO",
      onClick: () => {
        setPreviousPage("ENG_205");
        setCurrentPage("ENG_206");
      },
      endIcon: "arrow-right",
    },
  ],
};
